import { render, staticRenderFns } from "./CancelamentoAdesao.vue?vue&type=template&id=44285d2e&scoped=true"
import script from "./CancelamentoAdesao.vue?vue&type=script&lang=js"
export * from "./CancelamentoAdesao.vue?vue&type=script&lang=js"
import style0 from "./CancelamentoAdesao.vue?vue&type=style&index=0&id=44285d2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44285d2e",
  null
  
)

export default component.exports